/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Create_NameInputs */

const en_statement_taxonomy_create_name = /** @type {(inputs: Statement_Taxonomy_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template name`)
};

const nl_statement_taxonomy_create_name = /** @type {(inputs: Statement_Taxonomy_Create_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjabloonnaam`)
};

/**
* | output |
* | --- |
* | "Template name" |
*
* @param {Statement_Taxonomy_Create_NameInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_create_name = /** @type {((inputs?: Statement_Taxonomy_Create_NameInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Create_NameInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_create_name(inputs)
	return en_statement_taxonomy_create_name(inputs)
});